<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" lg="6" md="12">
        <v-card outlined>
          <v-list-item>
            <v-list-item-avatar>
                <v-icon>mdi-tools</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline">企業情報</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-form ref="client_profile_form" v-model="valid" @submit.prevent>
              <v-text-field label="企業名称" v-model="name" :rules="clientNameRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-list>
                <v-list-item-title>テーマ配色</v-list-item-title>
                <v-row class="ml-5">
                  <v-radio-group v-model="theme" v-for="item in themes" :key="item.id">
                    <v-radio :label="item.name" :value="item"/>
                  </v-radio-group>
                </v-row>
              </v-list>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.prevent="checkDialog" :disabled="!valid" depressed>確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleUpdate
        @updated="dialogUpdate" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import { UserStateActions } from "@/store/module/user-state";
  import ClientMasterApi from "@/api/client-master-api";
  import CustomDialog from "@/components/custom_ui/CustomDialog";
  import Rule from "@/validation/rules";
  import statusList from "@/helpers/const";

  export default {
    name: "EditClientProfile",
    components: {
      CustomDialog
    },
    props: ["user"],
    data: () => ({
      // 共通コンポーネント: ダイアログ関連
      loading: false,
      dialogMaxWith: 500,
      dialogTitle: '',
      dialogItems: [],
      dialogDrawer: false,

      // フォームの項目
      name: '',
      theme: '',

      // プルダウン項目
      themes: [],

      // バリデーション関連
      valid: true,
      clientNameRules: Rule.clientNameRules,
      themeRules: Rule.themeRules,
    }),
    created () { this.initialize(); },
    destroyed() { this.$emit('theme'); },
    watch: {
      // プルダウン選択でテーマ配色をプレビューする
      name () { this.inputValidation(); },
      theme () { this.inputValidation(); }
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.isLoading();
        this.clientMasterApi = new ClientMasterApi();
        const promise = this.clientMasterApi.info(this.user.company_id);
        promise.then(response => {
          this.name = response.data.body.client_info.name;
          this.themes = response.data.body.theme_list;
          this.theme = this.themes.find((v) => v.id === response.data.body.client_info.theme_no);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else if (error.response.data.status == statusList.status.entityError) {
              this.$router.push({ name: "Dashboard" });
              this.$emit("error",error.response.data.message);
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      },
      inputValidation() {
        if (this.$refs.client_profile_form.validate()) {
          this.$emit('theme', this.theme.id);
        }
      },
      checkDialog() {
        this.dialogTitle = "更新しますか？";
        this.dialogItems = [
          { name: '企業名称', value: this.name },
          { name: 'テーマ配色', value: this.theme.name },
        ];
        this.dialogDrawer = true;
      },
      dialogCancel() {
        this.dialogDrawer = false;
      },
      // 確認ダイアログの「更新」確定ボタン押下イベント
      dialogUpdate() {
        this.isLoading();
        const params = {
            name: this.name,
            theme_no: this.theme.id
        };
        const promise = this.clientMasterApi.update(this.user.company_id, params);
        promise.then((response) => {
            // セッション情報オブジェクトを更新
            this.user.company_name = this.name;
            this.user.theme_no = this.theme.id;

            // セッションストレージ内の情報を更新
            this.$store.dispatch(UserStateActions.setUser, this.user);
            this.dialogDrawer = false;
            this.$emit('success', response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.dialogDrawer = false;
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      }
    },
  };
</script>
